import ComponentWithSocket from '../../../lib/component';
import {Component} from 'vue-property-decorator';

@Component
export default class SlidesAdd extends ComponentWithSocket {
    public addSlide: {
        url: string;
        image: any;
        position: number;
    } = {
        url: '',
        image: '',
        position: 1
    };

    public addBtnLoading: boolean = false;
    public addSlideSuccess: string = '';
    public addSlideError: string = '';

    constructor() {
        super();
    }

    async addSlideAction() {
        if (!this.addSlide.image || !this.addSlide.url || !this.addSlide.position) {
            alert('Te rugam sa completezi toate datele din formular');
            return;
        }

        let image: any = '';
        image = await this.convertToBase64(this.addSlide.image)
        let payload = {
            image: image,
            url: this.addSlide.url,
            position: this.addSlide.position
        };

        this.addBtnLoading = true;

        await fetch(`${process.env.API2_URL}/slide`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
                this.addSlideError = `Eroare: ${response.status}`;
                this.addSlideSuccess = '';
            }

            this.addBtnLoading = false;

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.addSlideSuccess = data.message;
                this.addSlideError = '';
                this.addSlide.image = '';
                this.addSlide.url = '';
                this.addSlide.position = 1;
            } else {
                this.addSlideError = data.message;
                this.addSlideSuccess = '';
            }

            this.addBtnLoading = false;
        }).catch(error => {
            console.error('Error:', error);
            this.addSlideError = error;
            this.addSlideSuccess = '';
            this.addBtnLoading = false;
        });
    }

    convertToBase64(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                if (!e.target) {
                    reject(new Error('No target'));
                    return;
                }

                resolve(e.target.result);
            };

            reader.onerror = error => {
                reject(error);
            };

            reader.readAsDataURL(image);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/slides/add/index.ts